module.exports = __webpack_public_path__ + "ptc_momoro_F1_2.3f532cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_F1_2.jpg
// module id = Latz
// module chunks = 0